import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "../../hooks/fetchWithAuth";
import "../../App.css";
import "../../index.css";
import {Box,Button,Paper,IconButton,TextField,Typography,Tooltip,Chip,} from "@mui/material";
import { DragDropContext } from "react-beautiful-dnd";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import ClearIcon from "@mui/icons-material/Clear";
import Modal from "react-modal";
import AddIcon from "@mui/icons-material/Add";
import Alerts from "../Alert";
import Alerts2 from "../Alert2";
import LoadScreen from "../Loader";
import Navbar from "../Navbar";
import config from "../../config";
import CardModal from "../CardModal/CardModal";
import CardList from "../CardList/CardList";
import CryptoJS from "crypto-js";
import "./Board.css";
import getCookie from "../../hooks/getCookie";
import StrictModeDroppable from "../StrictModeDroppable";
import Avatar from "@mui/material/Avatar";
import { getAvatarUrl } from "../../utils/getAvatarUrl";
import io from "socket.io-client";
import MenuLateral from "../MenuLateral/MenuLateral";

const inicialColumns = [];

Modal.setAppElement("#root"); // Necessário para acessibilidade

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}

function Board() {
  const backendIp = config.backend_ip;
  const sessionId = getCookie("session_id");
  const nameComplete = getCookie("nome_completo");
  const storedUserId = getCookie("userId");
  const username = getCookie("username");
  const boardId = getCookie("boardId");
  const boardTitle = getCookie("boardTitle");

  const [columns, setColumns] = useState(inicialColumns);
  const [addingCard, setAddingCard] = useState({
    columnId: null,
    cardName: "",
  });
  const [selectedCard, setSelectedCard] = useState(null);
  const [upCard, setUpCard] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [cardDetails, setCardDetails] = useState({
    title: "",
    description: "",
    comments: [],
    labels: [],
    tasks: [],
  });
  const [showArchiveList, setShowArchiveList] = useState(false);
  const [newListName, setNewListName] = useState("");
  const [addingList, setAddingList] = useState(false);
  const [selectedImage2, setSelectedImage2] = useState(null);
  const [usersInCards, setUsersInCards] = useState([]);
  const [tagsInCards, setTagsInCards] = useState([]);
  const [commentsCount, setCommentsCount] = useState([]);
  const [archivesCount, setArchivesCount] = useState([]);
  const [comments, setComments] = useState([]);
  const [progressTasks, setProgressTasks] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [coverColor, setCoverColor] = useState([]);
  const [coverImage, setCoverImage] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isEditing2, setIsEditing2] = useState(false);
  const [newTitle, setNewTitle] = useState("");
  const [dialogOpenLista, setDialogOpenLista] = useState(false);
  const [logs, setLogs] = useState([]);
  const [alert, setAlert] = React.useState(null);
  const [alert2, setAlert2] = React.useState(null);
  const [selectedListId, setSelectedListId] = useState(null);
  const [selectedListName, setSelectedListName] = useState(null);
  const [isCopyingList, setIsCopyingList] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredColumns, setFilteredColumns] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [availableTags, setAvailableTags] = useState([]);
  const [showTagFilter, setShowTagFilter] = useState(false);
  const [isCopy, setIsCopy] = useState(false);
  const [isUserAllowed, setIsUserAllowed] = useState(true);
  const { cardId } = useParams();
  const editRef = useRef(null);
  const navigate = useNavigate();
  const openList = Boolean(anchorEl);

  const [notes, setNotes] = useState([]);
  const [addingNote, setAddingNote] = useState({ listId: null, noteName: "" });
  const [collapsedLists, setCollapsedLists] = useState(new Set());
  const [boardBackgroundColor, setBoardBackgroundColor] = useState(null);
  const [isDarkMode, setIsDarkMode] = useState(
    document.body.classList.contains("dark")
  );
  const [workingUsers, setWorkingUsers] = useState([]);
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    // Use a URL do socket definida no config
    const socketUrl = config.socket_url;
    const socketPath = "/socket.io/";
    if (!socketUrl) {
      return;
    }
    const newSocket = io(socketUrl, {
      transports: ["websocket"],
      reconnection: true,
      path: socketPath,
      secure: true,
    });
    setSocket(newSocket);

    return () => {
      if (newSocket) {
        newSocket.disconnect();
      }
    };
  }, []);

  useEffect(() => {
    if (!socket) return;

    // Entra na sala do board
    if (boardId) {
      socket.emit("join", { room: boardId });
    }

    // Escuta eventos de atualização do board
    socket.on("board_update", (data) => {
      if (
        (data.action === "add_list" && String(data.list_id)) || // ADICIONAR LISTA
        (data.action === "update_list" && String(data.list_id)) || // EDITAR LISTA
        (data.action === "delete_list" && String(data.list_id)) || // DELETAR LISTA
        (data.action === "update_board_background" && String(data.list_id)) || // ATUALIZAR FUNDO DO QUADRO
        data.action === "add_card" || // CRIAR CARTÃO
        data.action === "add_note" || // CRIAR NOTA
        data.action === "update_note" || // ATUALIZAR NOTA
        data.action === "update_working_users" || // ATUALIZAR USUÁRIOS TRABALHANDO
        data.action === "update_lists_order" || // ATUALIZAÇÃO DA ORDEM DAS LISTAS
        data.action === "update_cards_order" || // ATUALIZAÇÃO DA ORDEM DOS CARDS
        data.action === "update_cards_notes_order" || // ATUALIZAÇÃO DA ORDEM DAS NOTAS
        data.action === "delete_note" // DELETAR NOTA
      ) {
        // Re-fetch lists e dados do board
        fetchTiBoardData();
        fetchCommentsCount();
        fetchTagsInCards();
        fetchUsersInCards();
        fetchCoverImage();
        fetchCoverColor();
        fetchProgressTasks();
        fetchBoardBackground();
        fetchNotes();
        fetchWorkingUsers();
      }

      // Atualiza etiquetas em tempo real se houver subação de tag
      if (
        data.subaction === "create_tag" ||
        data.subaction === "update_tag" ||
        data.subaction === "delete_tag"
      ) {
        fetchTagsInCards();
        fetchAvailableTags();
      }
    });

    // Adiciona listener para atualização de descrição do card em tempo real
    socket.on("card_update", (data) => {
      if (
        data.action === "update_description" &&
        selectedCard &&
        String(selectedCard.id) === String(data.card_id)
      ) {
        setCardDetails((prev) => ({
          ...prev,
          description: data.card_description,
        }));
      }
    });

    return () => {
      socket.off("board_update");
      socket.off("card_update");
    };
  }, [socket, boardId, selectedCard]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        // 1. Registra o usuário como trabalhando
        if (sessionId && boardId && storedUserId && username) {
          try {
            await axios.put(`${config.backend_ip}/api/board/ti/set_working`, {
              board_id: boardId,
              user_id: storedUserId,
              username: username,
              session_id: sessionId,
            });
          } catch (err) {
            // ignora
          }
        }

        // 2. Busca dados do board
        await fetchTiBoardData();
        await fetchUsersInCards();
        await fetchCommentsCount();
        await fetchArchivesCount();
        await fetchTagsInCards();
        await fetchAvailableTags();
        await fetchProgressTasks();
        await fetchCoverImage();
        await fetchCoverColor();
        await fetchNotes();
        await fetchBoardBackground();

        // 3. Busca usuários trabalhando AGORA (depois de registrar)
        if (boardId) {
          try {
            const res = await axios.get(
              `${config.backend_ip}/api/board/ti/working_users`,
              {
                params: { board_id: boardId },
              }
            );
            setWorkingUsers(res.data);
          } catch (err) {
            setWorkingUsers([]);
          }
        }
      } catch (error) {
        setAlert2({ message: "Erro ao obter os dados", severity: "error" });
      } finally {
        setLoading(false);
      }
    };

    if (sessionId != null) {
      fetchData();
    } else {
      navigate("/");
    }
  }, [nameComplete, navigate]);

  useEffect(() => {
    const handleRemoveWorking = () => {
      if (sessionId && boardId && storedUserId && username) {
        axios
          .put(`${config.backend_ip}/api/board/ti/remove_working`, {
            board_id: boardId,
            user_id: storedUserId,
            username: username,
            session_id: sessionId,
          })
          .catch(() => {
            /* ignore */
          });
      }
    };

    window.addEventListener("beforeunload", handleRemoveWorking);

    return () => {
      window.removeEventListener("beforeunload", handleRemoveWorking);
      handleRemoveWorking();
    };
  }, [boardId, storedUserId, username, sessionId]);

  useEffect(() => {
    if (selectedCard || upCard) {
      listComments(selectedCard.id)
        .then((comments) => {
          setComments(comments);
        })
        .catch((error) => {
          setAlert2({
            message: "Erro ao carregar comentários",
            severity: "error",
          });
        });

      fetchLogs(selectedCard.id);
    }
  }, [selectedCard, upCard]);

  useEffect(() => {
    if (cardId) {
      const card = columns
        .flatMap((column) => column.cards)
        .find((card) => card.id.toString() === cardId);
      if (card) {
        openModal(card);
      }
    }
  }, [cardId, columns]);

  useEffect(() => {
    const filtered = columns.map((column) => ({
      ...column,
      cards: column.cards.filter((card) => {
        // Filtro por texto
        const matchesSearch = card.title.toLowerCase().includes(searchQuery.toLowerCase());
        
        // Filtro por tags - se não há tags selecionadas, mostrar todos
        if (selectedTags.length === 0) {
          return matchesSearch;
        }
        
        // Verificar se o card tem pelo menos uma das tags selecionadas
        const cardTags = tagsInCards
          .filter(tag => tag.card_id === card.id)
          .map(tag => tag.tag_id);
        
        const hasSelectedTag = selectedTags.some(selectedTagId => 
          cardTags.includes(selectedTagId)
        );
        
        return matchesSearch && hasSelectedTag;
      }),
    }));
    setFilteredColumns(filtered);
  }, [searchQuery, columns, selectedTags, tagsInCards]);

  useEffect(() => {
    const handleClick = (event) => {
      const target = event.target.closest(".clickable-image-wrapper");
      if (target) {
        const imageSrc = target.getAttribute("data-src");
        handleImageClick2(imageSrc);
      }
    };

    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);

  useEffect(() => {
    const checkUser = async () => {
      if (username) {
        if (username === 'marcos' || username === 'sandro') {
          setIsUserAllowed(true);
        } else {
          const userBelongsToBoard = await checkUserBelongsToBoard(
            storedUserId,
            boardId
          );
          setIsUserAllowed(userBelongsToBoard);
        }
      }
    };
    checkUser();
  }, [username, storedUserId, boardId]);

  useEffect(() => {
    // Atualiza cor de fundo e modo escuro/claro
    const applyBackgroundColor = () => {
      const htmlElement = document.documentElement;
      const dark = document.body.classList.contains("dark");
      setIsDarkMode(dark); // Atualiza estado imediatamente

      if (boardBackgroundColor) {
        htmlElement.style.background = boardBackgroundColor;
      } else {
        htmlElement.style.background = dark ? "#1e1e1e" : "#f2f2f2";
      }
    };

    applyBackgroundColor();

    const observer = new MutationObserver(() => {
      applyBackgroundColor();
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => {
      observer.disconnect();
    };
  }, [boardBackgroundColor]);

  useEffect(() => {
    setNewTitle("");
  }, [selectedListName]);

  const fetchWorkingUsers = async () => {
    try {
      const res = await axios.get(
        `${config.backend_ip}/api/board/ti/working_users`,
        {
          params: { board_id: boardId },
        }
      );
      setWorkingUsers(res.data);
    } catch (err) {
      setWorkingUsers([]);
    }
  };

  useEffect(() => {
    let interval;
    if (boardId) {
      fetchWorkingUsers();
      interval = setInterval(fetchWorkingUsers, 60000);
    }
    return () => clearInterval(interval);
  }, [boardId]);

  useEffect(() => {
    if (!isUserAllowed) {
      setAlert2({
        message: "Você não tem permissão para acessar este quadro.",
        severity: "error",
      });
    }
  }, [isUserAllowed]);

  if (!isUserAllowed) {
    return <div>Você não tem permissão para acessar este quadro.</div>;
  }

  const checkUserBelongsToBoard = async (storedUserId, boardId) => {
    try {
      const response = await axios.post(
        `${backendIp}/api/board/ti/checkUserBelongsToBoard`,
        {
          session: sessionId,
          user: username,
          username: storedUserId,
          board_id: boardId,
        }
      );
      return response.data.belongsToBoard;
    } catch (error) {
      setAlert2({ message: "Erro ao carregar usuários", severity: "error" });
      return false;
    }
  };

  const handleImageClick2 = (imageSrc) => {
    setSelectedImage2(imageSrc);
  };

  const handleCloseImage2 = () => {
    setSelectedImage2(null);
  };

  const fetchLogs = async (cardId) => {
    try {
      const response = await axios.get(`${backendIp}/api/board/ti/logs`, {
        params: { card_id: cardId },
      });

      setLogs(response.data);
    } catch (error) {
      setAlert2({ message: "Erro ao buscar logs", severity: "error" });
    }
  };

  // Adicionar manipulador de eventos globalmente
  document.addEventListener("click", (event) => {
    if (event.target.closest(".clickable-image-wrapper")) {
      const imageSrc = event.target
        .closest(".clickable-image-wrapper")
        .getAttribute("data-src");
      handleImageClick2(imageSrc);
    }
  });

  const fetchCoverColor = async () => {
    try {
      const response = await axios.get(
        `${backendIp}/api/board/ti/list_cover_in_cards`
      );
      setCoverColor(response.data);
    } catch (error) {
      setAlert2({ message: "Erro ao buscar cor da capa", severity: "error" });
      setCoverColor();
    }
  };

  const fetchCoverImage = async () => {
    try {
      const response = await axios.get(
        `${backendIp}/api/board/ti/list_images_in_cards`
      );
      setCoverImage(response.data);
    } catch (error) {
      setAlert2({
        message: "Erro ao buscar imagem da capa",
        severity: "error",
      });
      setCoverImage([]);
    }
  };

  const fetchTiBoardData = async (selectedCard) => {
    try {
      const response = await axios.put(`${backendIp}/api/board/ti`, {
        board_id: boardId,
        session_id: sessionId,
        username: username,
      });
      setColumns(response.data);

      if (selectedCard) {
        const comments = await listComments(selectedCard.id);
        setComments(comments);
      }
    } catch (error) {
      setAlert2({
        message: "Erro ao buscar dados do quadro",
        severity: "error",
      });
    }
  };

  const fetchUsersInCards = async () => {
    try {
      const response = await axios.get(
        `${backendIp}/api/board/ti/list_users_in_cards`
      );
      setUsersInCards(response.data);
    } catch (error) {
      setAlert2({ message: "Erro ao listar cartões", severity: "error" });
    }
  };

  const fetchTagsInCards = async () => {
    try {
      const response = await axios.get(
        `${backendIp}/api/board/ti/list_tags_in_cards`
      );
      setTagsInCards(response.data);
    } catch (error) {
      setAlert2({ message: "Erro ao listar etiquetas", severity: "error" });
    }
  };

  const fetchAvailableTags = async () => {
    try {
      const response = await axios.put(
        `${backendIp}/api/board/ti/list_tags`,
        {
          board_id: boardId,
          session_id: sessionId,
          user: username
        }
      );
      setAvailableTags(response.data);
    } catch (error) {
      setAlert2({ message: "Erro ao carregar etiquetas do board", severity: "error" });
    }
  };

  const fetchCommentsCount = async () => {
    try {
      const response = await axios.get(
        `${backendIp}/api/board/ti/comments_count`
      );
      setCommentsCount(response.data);
    } catch (error) {
      setAlert2({ message: "Erro ao contar comentários", severity: "error" });
    }
  };

  const fetchArchivesCount = async () => {
    try {
      const response = await axios.get(
        `${backendIp}/api/board/ti/number_of_archives`
      );
      setArchivesCount(response.data);
    } catch (error) {
      setAlert2({ message: "Erro ao contar arquivos", severity: "error" });
    }
  };

  const fetchProgressTasks = async () => {
    try {
      const response = await axios.get(
        `${backendIp}/api/board/ti/list_tasks_progress`
      );
      setProgressTasks(response.data);
    } catch (error) {
      setAlert2({
        message: "Erro ao listar progresso das tarefas",
        severity: "error",
      });
    }
  };

  const onDragEnd = (result) => {
    try {
      const { source, destination, draggableId, type } = result;

      if (
        !destination ||
        (source.droppableId === destination.droppableId &&
          source.index === destination.index)
      ) {
        return;
      }

      // Se for drag de lista
      if (type === "LIST") {
        const newColumns = Array.from(columns);
        const [reorderedList] = newColumns.splice(source.index, 1);
        newColumns.splice(destination.index, 0, reorderedList);

        // Atualiza a ordem das listas
        const updatedColumns = newColumns.map((list, index) => ({
          ...list,
          list_order: index + 1,
        }));

        setColumns(updatedColumns);

        // Envia a nova ordem para o backend
        const listsOrder = updatedColumns.map((list, index) => ({
          list_id: list.list_id,
          list_order: index + 1,
        }));

        axios
          .put(`${backendIp}/api/board/ti/update_lists_order`, {
            lists_order: listsOrder,
            session_id: sessionId,
            username: username,
          })
          .catch((error) => {
            setAlert2({
              message: "Erro ao atualizar a ordem das listas",
              severity: "error",
            });
            // Reverter em caso de erro
            fetchTiBoardData();
          });

        return;
      }

      // Copia os dados atuais
      const newColumns = [...columns];
      const sourceColumn = newColumns.find(
        (col) => col.list_id === parseInt(source.droppableId)
      );
      const destinationColumn = newColumns.find(
        (col) => col.list_id === parseInt(destination.droppableId)
      );

      // Busca notes da lista de origem/destino
      const notesSource = notes.filter(
        (note) => note.list_id === sourceColumn.list_id
      );
      const notesDestination = notes.filter(
        (note) => note.list_id === destinationColumn.list_id
      );

      // Junta cards e notes para ordenação
      const itemsSource = [
        ...notesSource.map((note) => ({ ...note, _type: "note" })),
        ...sourceColumn.cards.map((card) => ({ ...card, _type: "card" })),
      ].sort((a, b) => (a.order || 0) - (b.order || 0));

      const itemsDestination =
        sourceColumn.list_id === destinationColumn.list_id
          ? itemsSource
          : [
              ...notesDestination.map((note) => ({ ...note, _type: "note" })),
              ...destinationColumn.cards.map((card) => ({
                ...card,
                _type: "card",
              })),
            ].sort((a, b) => (a.order || 0) - (b.order || 0));

      // Remove do source e adiciona no destino
      const [removed] = itemsSource.splice(source.index, 1);
      itemsDestination.splice(destination.index, 0, removed);

      // Atualiza ordem e lista_id dos itens
      const updateOrder = (items, list_id) => {
        let order = 1;
        items.forEach((item) => {
          item.order = order++;
          item.list_id = list_id;
        });
      };

      updateOrder(itemsSource, sourceColumn.list_id);
      if (sourceColumn.list_id !== destinationColumn.list_id) {
        updateOrder(itemsDestination, destinationColumn.list_id);
      }

      // Atualiza os arrays de cards e notes nas colunas
      sourceColumn.cards = itemsSource.filter((i) => i._type === "card");
      destinationColumn.cards = itemsDestination.filter(
        (i) => i._type === "card"
      );

      // Atualiza o estado das notas
      const updatedNotes = notes.map((note) => {
        if (
          itemsSource.find(
            (i) => i._type === "note" && i.note_id === note.note_id
          )
        ) {
          return itemsSource.find(
            (i) => i._type === "note" && i.note_id === note.note_id
          );
        }
        if (
          itemsDestination.find(
            (i) => i._type === "note" && i.note_id === note.note_id
          )
        ) {
          return itemsDestination.find(
            (i) => i._type === "note" && i.note_id === note.note_id
          );
        }
        return note;
      });
      setNotes(updatedNotes);

      setColumns(newColumns);

      // Envie para o backend a ordem de cards e notes
      axios
        .put(`${backendIp}/api/board/ti/update_cards_notes_order`, {
          columns: newColumns.map((col) => ({
            list_id: col.list_id,
            cards: col.cards.map((card) => ({
              id: card.id || card.card_id,
              order: card.order || card.card_order,
            })),
            notes: updatedNotes
              .filter((note) => note.list_id === col.list_id)
              .map((note) => ({
                id: note.note_id,
                order: note.order,
              })),
          })),
          session_id: sessionId,
          user: username,
          name_complete: nameComplete,
        })
        .then(() => {
          // ok, colocar tratativa de ok depois
        })
        .catch((err) => {
          setAlert2({
            message: "Arraste de lista indisponível",
            severity: "error",
          });
          // erro, colocar tratativa de erri depois
        });
    } catch (error) {
      setAlert2({ message: "Erro ao finalizar o arraste", severity: "error" });
    }
  };

  const handleAddCardClick = (listId) => {
    setAddingCard({ listId, cardName: "" });
  };

  const handleCardNameChange = (event) => {
    setAddingCard({ ...addingCard, cardName: event.target.value });
  };

  const handleCardNameKeyPress = (event, listId) => {
    if (event.key === "Enter" && addingCard.cardName.trim() !== "") {
      addCard(listId, addingCard.cardName.trim());
    }
  };

  const addCard = async (
    listId,
    cardName,
    old_card_id,
    copyChecklists,
    copyComments,
    copyTags,
    copyDescription,
    copyCover,
    copyMembers
  ) => {
    try {
      const response = await axios.put(`${backendIp}/api/board/ti/add_card`, {
        list_id: listId,
        title: cardName,
        description: "",
        old_card_id: old_card_id,
        copy_description: copyDescription,
        copy_checklist: copyChecklists,
        copy_tags: copyTags,
        copy_comments: copyComments,
        copy_cover: copyCover,
        copy_members: copyMembers,
        name_complete: nameComplete,
        user: username,
        session_id: sessionId,
      });

      const newCard = response.data;

      setAddingCard({ listId: null, cardName: "" });
      fetchTiBoardData();
      fetchTagsInCards();
      fetchProgressTasks();
      fetchUsersInCards();
      fetchCoverImage();
      fetchCoverColor();

      // Verifica se old_card_id está vazio para definir o alerta de sucesso
      if (!old_card_id) {
        setAlert2({ message: "Card criado com sucesso!", severity: "success" });
      } else {
        setAlert2({
          message: "Card copiado com sucesso!",
          severity: "success",
        });
      }

      // Remove o alerta após 3 segundos
      setTimeout(() => {
        setAlert(null);
      }, 3000);

      // Remove o alerta2 após 3 segundos
      setTimeout(() => {
        setAlert2(null);
      }, 3000);
    } catch (error) {
      // Define o alerta de erro
      setAlert2({ message: "Erro ao criar novo card", severity: "error" });

      // Remove o alerta após 3 segundos
      setTimeout(() => {
        setAlert2(null);
      }, 3000);
      setAlert2({
        message: "Erro ao adicionar novo cartão",
        severity: "error",
      });
    }
  };

  const listComments = async (selectedCard) => {
    try {
      const response = await axios.put(
        `${backendIp}/api/board/ti/list_comments`,
        {
          card_id: selectedCard,
          session_id: sessionId,
          user: username,
        }
      );

      const comments = response.data;
      return comments;
    } catch (error) {
      setAlert2({ message: "Erro ao listar comentários", severity: "error" });
    }
  };

  const generateCardUrl = (cardId) => {
    return `${window.location.origin}/board/${boardId}/card/${cardId}`;
  };

  const openModal = (card) => {
    const cardUrl = generateCardUrl(card.id);
    // Busca o nome da lista do card
    let listName = "";
    for (const col of columns) {
      if (col.cards.some((c) => c.id === card.id)) {
        listName = col.list_name;
        break;
      }
    }
    setSelectedCard({ ...card, url: cardUrl, list_name: listName });
    setCardDetails({
      title: card.title || "",
      description: card.description || "",
      comments: card.comments || [],
      labels: card.labels || [],
      tasks: card.tasks || [],
    });
    setModalIsOpen(true);
    fetchLogs(card.id);
    navigate(`/board/${boardId}/card/${card.id}`);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    fetchCommentsCount();
    fetchArchivesCount();
    fetchProgressTasks();
    navigate(`/board/${boardId}`);
  };

  const saveCardDetails = () => {
    const updatedColumns = columns.map((list) => {
      if (list.list_id === selectedCard.list_id) {
        return {
          ...list,
          cards: list.cards.map((card) => {
            if (card.id === selectedCard.id) {
              return {
                ...card,
                title: cardDetails.title,
                description: cardDetails.description,
                comments: cardDetails.comments,
                labels: cardDetails.labels,
                tasks: cardDetails.tasks,
              };
            }
            return card;
          }),
        };
      }
      return list;
    });
    setColumns(updatedColumns);
    closeModal();
  };

  const addList = async () => {
    try {
      const response = await axios.put(`${backendIp}/api/board/ti/add_list`, {
        list_name: newListName,
        board_id: boardId,
        copy_list: isCopy,
        old_list_id: selectedListId,
        session_id: sessionId,
        username: username,
      });

      const newList = response.data;
      setNewListName("");
      setAddingList(false);
      fetchTiBoardData();
      fetchCommentsCount();
      fetchTagsInCards();
      fetchUsersInCards();
      fetchCoverImage();
      fetchCoverColor();
      fetchProgressTasks();

      // Define o alerta de sucesso
      setAlert2({ message: "Lista criada com sucesso!", severity: "success" });

      // Remove o alerta após 3 segundos
      setTimeout(() => {
        setAlert2(null);
      }, 3000);
    } catch (error) {
      // Define o alerta de erro
      setAlert2({ message: "Erro ao criar nova lista", severity: "error" });

      // Remove o alerta após 3 segundos
      setTimeout(() => {
        setAlert2(null);
      }, 3000);
      setAlert2({ message: "Erro ao adicionar nova lista", severity: "error" });
    }
  };

  const addTagToCard = async (tagId) => {
    try {
      if (tagId) {
        const response = await axios.put(
          `${backendIp}/api/board/ti/set_tag_on_card`,
          {
            tag_id: tagId,
            card_id: selectedCard.id,
            session_id: sessionId,
            username: username,
          }
        );
        fetchTagsInCards();
      }
    } catch (error) {
      setAlert2({
        message: "Erro ao adicionar etiqueta ao card",
        severity: "error",
      });
    }
  };

  const handleSetSelectedTag = (tagId) => {
    try {
      addTagToCard(tagId);
    } catch (error) {
      setAlert2({ message: "Erro ao mapear estado", severity: "error" });
    }
  };

  const addUserToCardState = (memberName, cardId) => {
    try {
      const memberInCardName = {
        user_in_card: memberName,
        user_card_id: cardId,
      };

      setUsersInCards((prevUsersInCards) => {
        // Verifica se o membro já está na lista
        const memberExists = prevUsersInCards.some(
          (user) =>
            user.user_in_card === memberName && user.user_card_id === cardId
        );

        // Se o membro já existir, remove ele
        if (memberExists) {
          return prevUsersInCards.filter(
            (user) =>
              !(
                user.user_in_card === memberName && user.user_card_id === cardId
              )
          );
        }

        // Se o membro não existir, adiciona ele
        return [...prevUsersInCards, memberInCardName];
      });
    } catch (error) {
      setAlert2({ message: "Usuário não encontrado", severity: "error" });
    }
  };

  const handleCloseModal = () => {
    saveCardDetails();
    closeModal();
    fetchTiBoardData();
    fetchCommentsCount();
    fetchArchivesCount();
    fetchProgressTasks();
  };

  const handleToggleArchive = () => {
    setShowArchiveList(!showArchiveList);
  };

  const handleNewListName = (event) => {
    setNewListName(event.target.value);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleTagFilter = (tagId) => {
    setSelectedTags(prev => {
      if (prev.includes(tagId)) {
        return prev.filter(id => id !== tagId);
      } else {
        return [...prev, tagId];
      }
    });
  };

  const clearTagFilter = () => {
    setSelectedTags([]);
  };

  const handlePopoverOpen = (event, list_id, list_name) => {
    setAnchorEl(event.currentTarget);
    setSelectedListId(list_id);
    setSelectedListName(list_name);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setIsEditing2(false);
    setIsCopyingList(false);
    handleSetIsNotCopy();
  };

  const handleEditListClick = () => {
    setIsEditing2(true);
    setIsCopyingList(false);
    handleSetIsNotCopy();
  };

  const handleDeleteList = async (list_id) => {
    try {
      await axios.put(`${backendIp}/api/board/ti/delete_list`, {
        list_id: list_id,
        session_id: sessionId,
        username: username,
      });
      fetchTiBoardData();
      handlePopoverClose();
      setDialogOpenLista(false);
      // Define o alerta de sucesso
      setAlert2({
        message: "Lista deletada com sucesso!",
        severity: "success",
      });

      // Remove o alerta após 3 segundos
      setTimeout(() => {
        setAlert2(null);
      }, 3000);
    } catch (error) {
      // Define o alerta de erro
      setAlert2({ message: "Erro ao deletar lista", severity: "error" });

      // Remove o alerta após 3 segundos
      setTimeout(() => {
        setAlert2(null);
      }, 3000);
    }
  };

  const handleTitleChangeList = (event) => {
    setNewTitle(event.target.value);
  };

  const handleTitleCopyList = (event) => {
    setNewListName(event.target.value);
  };

  const handleTitleSubmitList = async (list_id) => {
    if (!newTitle.trim()) {
      setIsEditing2(false);
      handlePopoverClose();
      return;
    }

    try {
      const response = await axios.put(
        `${backendIp}/api/board/ti/update_list`,
        {
          list_id: list_id,
          list_title: newTitle,
          user: username,
          session_id: sessionId,
        }
      );
      fetchTiBoardData();
      // Define o alerta de sucesso
      setAlert2({ message: "Lista editada com sucesso!", severity: "success" });

      // Remove o alerta após 3 segundos
      setTimeout(() => {
        setAlert2(null);
      }, 3000);
    } catch (error) {
      // Define o alerta de erro
      setAlert2({ message: "Erro ao editar lista", severity: "error" });

      // Remove o alerta após 3 segundos
      setTimeout(() => {
        setAlert2(null);
      }, 3000);
      setAlert2({ message: "Erro ao atualizar checklist", severity: "error" });
    }
    setIsEditing2(false);
    handlePopoverClose();
  };

  const handleColorListRemove = async (list_id) => {
    try {
      const response = await axios.put(
        `${backendIp}/api/board/ti/update_list`,
        {
          list_id: list_id,
          background_color: "",
          user: username,
          session_id: sessionId,
        }
      );
      fetchTiBoardData();
      // Define o alerta de sucesso
      setAlert2({ message: "Lista editada com sucesso!", severity: "success" });

      // Remove o alerta após 3 segundos
      setTimeout(() => {
        setAlert2(null);
      }, 3000);
    } catch (error) {
      // Define o alerta de erro
      setAlert2({ message: "Erro ao editar lista", severity: "error" });

      // Remove o alerta após 3 segundos
      setTimeout(() => {
        setAlert2(null);
      }, 3000);
      setAlert2({ message: "Erro ao atualizar checklist", severity: "error" });
    }
    setIsEditing2(false);
    handlePopoverClose();
  };

  const handleNewTitleClick = () => {
    setIsCopyingList(true);
    handleSetIsCopy();
    setNewListName(selectedListName);
    setIsEditing2(false); // Certifique-se de desativar o modo de edição
  };

  const handleSetIsCopy = () => {
    setIsCopy(true);
  };

  const handleSetIsNotCopy = () => {
    setIsCopy(false);
  };

  const fetchNotes = async () => {
    try {
      const response = await axios.get(`${backendIp}/api/board/ti/notes`, {
        params: { board_id: boardId },
      });
      setNotes(response.data);
    } catch (error) {
      setAlert2({ message: "Erro ao buscar notas:", severity: "error" });
    }
  };
  const showAlert = (message, severity = "success") => {
    setAlert2({ message, severity });
    setTimeout(() => {
      setAlert2(null); // limpa o alert após 3 segundos
    }, 3000);
  };

  // Adicionar nota
  const addNote = async (listId, noteName) => {
    try {
      const response = await axios.put(`${backendIp}/api/board/ti/add_note`, {
        list_id: listId,
        title: noteName,
        board_id: boardId,
        session_id: sessionId,
        username: username,
      });
      setAddingNote({ listId: null, noteName: "" });
      fetchNotes();
      setAlert2({ message: "Nota criada com sucesso!", severity: "success" });
      setTimeout(() => setAlert2(null), 3000);
    } catch (error) {
      setAlert2({ message: "Erro ao criar nota", severity: "error" });
      setTimeout(() => setAlert2(null), 3000);
      setAlert2({ message: "Erro ao adicionar nota:", severity: "error" });
    }
  };

  // Handlers para adicionar nota
  const handleAddNoteClick = (listId) => {
    setAddingNote({ listId, noteName: "" });
  };
  const handleNoteNameChange = (event) => {
    setAddingNote({ ...addingNote, noteName: event.target.value });
  };
  const handleNoteNameKeyPress = (event, listId) => {
    if (event.key === "Enter" && addingNote.noteName.trim() !== "") {
      addNote(listId, addingNote.noteName.trim());
    }
  };

  // Atualizar conteúdo da nota
  const updateNote = async (noteId, { title, content, color }) => {
    try {
      await axios.put(`${backendIp}/api/board/ti/update_note`, {
        note_id: noteId,
        title,
        content,
        color,
        session_id: sessionId,
        username: username,
      });
      fetchNotes();
    } catch (error) {
      setAlert2({ message: "Erro ao atualizar nota:", severity: "error" });
    }
  };

  const toggleListCollapse = (listId) => {
    setCollapsedLists((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(listId)) {
        newSet.delete(listId);
      } else {
        newSet.add(listId);
      }
      return newSet;
    });
  };

  const fetchBoardBackground = async () => {
    try {
      const response = await axios.get(
        `${backendIp}/api/board/ti/get_board_background`,
        {
          params: { board_id: boardId },
        }
      );
      setBoardBackgroundColor(response.data.background_color);
    } catch (error) {
      setAlert2({
        message: "Erro ao buscar cor do quadro:",
        severity: "error",
      });
      setBoardBackgroundColor(null);
    }
  };

  return (
    <ErrorBoundary>
      <Navbar closeModal={handleCloseModal} selectedCard={selectedCard} />
      <Box
        className="container-fundo"
        sx={{
          minWidth: "100%",
          width: "fit-content",
          maxHeight: "95vh",
          padding: "70px 0px 0px 0px",
        }}
      >
        {alert && <Alerts message={alert.message} severity={alert.severity} />}
        {alert2 && (
          <Alerts2 message={alert2.message} severity={alert2.severity} />
        )}
        {loading ? (
          <div
            style={{
              width: "100vw",
              height: "auto",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <LoadScreen />
          </div>
        ) : (
          <>
            <div style={{ display: "flex", marginTop: "70px" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginLeft: "40px",
                }}
              >
                <MenuLateral
                  boardId={boardId}
                  toggleArchiveList={handleToggleArchive}
                  showArchiveList={showArchiveList}
                  boardBackgroundColor={boardBackgroundColor}
                  setBoardBackgroundColor={setBoardBackgroundColor}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  height: "80px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "20px",
                    position: "absolute",
                    top: "90px",
                    left: "20px",
                    zIndex: 1000,
                    padding: "10px 20px 20px 20px",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: "bold",
                      color: boardBackgroundColor
                        ? "rgba(255,255,255,0.95)"
                        : "inherit",
                      textShadow: boardBackgroundColor
                        ? "1px 1px 2px rgba(0,0,0,0.25)"
                        : "none",
                      transition: "color 0.2s",
                    }}
                  >
                    {boardTitle}
                  </Typography>
                  {/* <TuneIcon
                    sx={{
                      fontWeight: "bold",
                      color: boardBackgroundColor
                        ? "rgba(255,255,255,0.95)"
                        : "inherit",
                      textShadow: boardBackgroundColor
                        ? "1px 1px 2px rgba(0,0,0,0.25)"
                        : "none",
                      transition: "color 0.2s",
                    }}
                    style={{ cursor: "pointer" }}
                    // onClick={handleTuneIconClick}
                  /> */}
                </div>
                <div
                  style={{
                    position: "fixed",
                    top: "80px",
                    right: "20px",
                    zIndex: 1000,
                    padding: "10px 20px 20px 20px",
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                    background: "transparent",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <Typography
                      variant="subtitle2"
                      sx={{
                        fontWeight: "bold",
                        mr: 1,
                        color: boardBackgroundColor
                          ? "rgba(255,255,255,0.95)"
                          : "inherit",
                        textShadow: boardBackgroundColor
                          ? "1px 1px 2px rgba(0,0,0,0.25)"
                          : "none",
                        transition: "color 0.2s",
                      }}
                    >
                      Ativos agora:
                    </Typography>
                    {workingUsers.map((user, idx) => (
                      <Tooltip
                        key={user.user_id.toString()}
                        title={user.username || "Sem nome"}
                        PopperProps={{
                          modifiers: [
                            {
                              name: "offset",
                              options: {
                                offset: [0, -10],
                              },
                            },
                          ],
                        }}
                      >
                        <Avatar
                          key={user.user_id || idx}
                          alt={user.username || "Usuário"}
                          className="comment-avatar-card"
                          src={getAvatarUrl(user.username)}
                        />
                      </Tooltip>
                    ))}
                  </div>
                  <Paper component="form" className="search-bar">
                    <InputBase
                      sx={{ ml: 1, flex: 1 }}
                      placeholder="Buscar cartão"
                      inputProps={{ "aria-label": "buscar cartão" }}
                      value={searchQuery}
                      onChange={handleSearchChange}
                      className="search-input"
                    />
                    <IconButton
                      type="button"
                      sx={{ p: "10px" }}
                      aria-label="search"
                    >
                      <SearchIcon className="search-icon" />
                    </IconButton>
                  </Paper>
                  
                  {/* Filtro por etiquetas */}
                  <div style={{ position: 'relative' }}>
                    <IconButton
                      onClick={() => setShowTagFilter(!showTagFilter)}
                      className={`filter-button ${selectedTags.length > 0 ? 'active' : ''}`}
                      sx={{
                        p: "10px",
                        color: boardBackgroundColor
                          ? "rgba(255,255,255,0.95)"
                          : "inherit",
                      }}
                      title="Filtrar por etiquetas"
                    >
                      <FilterListIcon />
                      {selectedTags.length > 0 && (
                        <span className="filter-badge">
                          {selectedTags.length}
                        </span>
                      )}
                    </IconButton>
                    
                    {showTagFilter && (
                      <Paper className="tag-filter-panel">
                        <div className="filter-header">
                          <Typography 
                            variant="subtitle2" 
                            className="filter-title"
                            sx={{ fontWeight: 'bold' }}
                          >
                            Filtrar por etiquetas
                          </Typography>
                          <IconButton
                            size="small"
                            onClick={() => setShowTagFilter(false)}
                            className="close-filter-button"
                          >
                            <ClearIcon fontSize="small" />
                          </IconButton>
                        </div>
                        
                        {selectedTags.length > 0 && (
                          <div style={{ marginBottom: '12px' }}>
                            <Button
                              size="small"
                              onClick={clearTagFilter}
                              className="clear-filters-button"
                              sx={{ 
                                textTransform: 'none',
                                fontSize: '13px'
                              }}
                            >
                              Limpar filtros
                            </Button>
                          </div>
                        )}
                        
                        <div className="tags-container">
                          {availableTags.map(tag => (
                            <Chip
                              key={tag.tag_id}
                              label={tag.tag_name}
                              onClick={() => handleTagFilter(tag.tag_id)}
                              variant={selectedTags.includes(tag.tag_id) ? "filled" : "outlined"}
                              className={`tag-chip ${selectedTags.includes(tag.tag_id) ? 'selected' : ''}`}
                              sx={{
                                backgroundColor: selectedTags.includes(tag.tag_id) ? tag.color_hex : 'transparent',
                                borderColor: tag.color_hex,
                                color: selectedTags.includes(tag.tag_id) ? '#fff' : tag.color_hex,
                                fontSize: '13px',
                                height: '28px',
                                cursor: 'pointer',
                                '&:hover': {
                                  backgroundColor: selectedTags.includes(tag.tag_id) 
                                    ? tag.color_hex 
                                    : `${tag.color_hex}20`,
                                }
                              }}
                            />
                          ))}
                        </div>
                        
                        {availableTags.length === 0 && (
                          <Typography 
                            variant="body2" 
                            className="no-tags-message"
                            sx={{ 
                              textAlign: 'center', 
                              py: 2 
                            }}
                          >
                            Nenhuma etiqueta encontrada
                          </Typography>
                        )}
                      </Paper>
                    )}
                  </div>
                </div>
              </div>
              <div className="cor-container-fundo">
                <Box className="box-container">
                  <ErrorBoundary>
                    <DragDropContext onDragEnd={onDragEnd}>
                      <StrictModeDroppable
                        droppableId="board"
                        direction="horizontal"
                        type="LIST"
                        isCombineEnabled={false}
                        ignoreContainerClipping={false}
                      >
                        {(provided) => (
                          <Box
                            className="box-container"
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              gap: "10px",
                              padding: "20px 20px 20px 0px",
                              minHeight: "400px",
                            }}
                          >
                            {filteredColumns.map((list, index) => (
                              <CardList
                                key={list.list_id}
                                list={list}
                                index={index}
                                openList={openList}
                                anchorEl={anchorEl}
                                handlePopoverOpen={handlePopoverOpen}
                                handlePopoverClose={handlePopoverClose}
                                isEditing2={isEditing2}
                                editRef={editRef}
                                newTitle={newTitle}
                                handleTitleChangeList={handleTitleChangeList}
                                handleTitleSubmitList={handleTitleSubmitList}
                                handleColorListRemove={handleColorListRemove}
                                isCopyingList={isCopyingList}
                                selectedListName={selectedListName}
                                handleTitleCopyList={handleTitleCopyList}
                                addList={addList}
                                dialogOpenLista={dialogOpenLista}
                                setDialogOpenLista={setDialogOpenLista}
                                handleDeleteList={handleDeleteList}
                                selectedListId={selectedListId}
                                handleEditListClick={handleEditListClick}
                                handleNewTitleClick={handleNewTitleClick}
                                addingCard={addingCard}
                                handleCardNameChange={handleCardNameChange}
                                handleCardNameKeyPress={handleCardNameKeyPress}
                                handleAddCardClick={handleAddCardClick}
                                coverColor={coverColor}
                                coverImage={coverImage}
                                openModal={openModal}
                                tagsInCards={tagsInCards}
                                commentsCount={commentsCount}
                                archivesCount={archivesCount}
                                progressTasks={progressTasks}
                                usersInCards={usersInCards}
                                showArchiveList={showArchiveList}
                                setAddingCard={setAddingCard}
                                setAddingNote={setAddingNote}
                                notes={notes.filter(
                                  (note) => note.list_id === list.list_id
                                )}
                                handleAddNoteClick={handleAddNoteClick}
                                handleNoteNameChange={handleNoteNameChange}
                                handleNoteNameKeyPress={handleNoteNameKeyPress}
                                addingNote={addingNote}
                                onUpdateNote={updateNote}
                                openNoteModal={null}
                                background={list.background_color}
                                setColumns={setColumns}
                                isCollapsed={collapsedLists.has(list.list_id)}
                                onToggleCollapse={() =>
                                  toggleListCollapse(list.list_id)
                                }
                                isDarkMode={isDarkMode}
                                fetchNotes={fetchNotes}
                                showAlert={showAlert}
                              />
                            ))}
                            {provided.placeholder}
                            {alert2 && (
                              <Alerts2
                                message={alert2.message}
                                severity={alert2.severity}
                              />
                            )}
                          </Box>
                        )}
                      </StrictModeDroppable>
                    </DragDropContext>
                  </ErrorBoundary>
                  <div className="column-add" style={{ width: "250px" }}>
                    {addingList ? (
                      <div className="add-card-input-wrapper">
                        <TextField
                          value={newListName}
                          onChange={handleNewListName}
                          onKeyPress={(e) =>
                            e.key === "Enter" &&
                            newListName.trim() !== "" &&
                            addList()
                          }
                          fullWidth
                          margin="normal"
                          autoFocus
                          onBlur={() => setAddingList(false)}
                          variant="outlined"
                          placeholder="Digite o nome da lista"
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              backgroundColor: "var(--input-bg-color, #fff)",
                              color: "var(--input-text-color, #000)",
                              "& fieldset": {
                                borderColor: "var(--input-border-color, #ccc)",
                              },
                              "&:hover fieldset": {
                                borderColor:
                                  "var(--input-hover-border-color, #aaa)",
                              },
                              "&.Mui-focused fieldset": {
                                borderColor:
                                  "var(--input-focus-border-color, #009373)",
                              },
                            },
                            "& .MuiInputBase-input": {
                              color: "var(--input-text-color, #000)",
                            },
                          }}
                        />
                      </div>
                    ) : (
                      <Button
                        className="button-add-list lista"
                        startIcon={<AddIcon />}
                        onClick={() => setAddingList(true)}
                        style={{
                          backgroundColor: "var(--button-bg-color, #f0f0f0)",
                          color: boardBackgroundColor
                            ? "rgba(173, 169, 169, 0.95)"
                            : "var(--button-text-color, #575757)",
                          textShadow: boardBackgroundColor
                            ? "1px 1px 2px rgba(117, 108, 108, 0.25)"
                            : "none",
                          borderRadius: "5px",
                          padding: "5px 15px",
                          fontWeight: "bold",
                          marginLeft: "7px",
                          transition: "background-color 0.3s, color 0.3s",
                          cursor: "pointer",
                        }}
                        onMouseEnter={(e) => {
                          const bgColor =
                            "var(--button-hover-bg-color, #e0e0e0)";
                          const textColor = boardBackgroundColor
                            ? "rgba(255,255,255,0.95)"
                            : "var(--button-hover-text-color, #000)";
                          e.currentTarget.style.backgroundColor = bgColor;
                          e.currentTarget.style.color = textColor;
                        }}
                        onMouseLeave={(e) => {
                          const bgColor = "var(--button-bg-color, #f0f0f073)";
                          const textColor = boardBackgroundColor
                            ? "rgba(158, 158, 158, 1)"
                            : "var(--button-text-color, #575757)";
                          e.currentTarget.style.backgroundColor = bgColor;
                          e.currentTarget.style.color = textColor;
                        }}
                      >
                        Adicionar lista
                      </Button>
                    )}
                  </div>
                </Box>
              </div>
            </div>
          </>
        )}
        <CardModal
          addCard={addCard}
          modalIsOpen={modalIsOpen}
          closeModal={handleCloseModal}
          selectedCard={selectedCard}
          cardDetails={cardDetails}
          comments={comments}
          usersInCards={usersInCards}
          boardId={boardId}
          fetchTiBoardData={fetchTiBoardData}
          setSelectedCard={setSelectedCard}
          addUserToCardState={addUserToCardState}
          fetchLogs={fetchLogs}
          logs={logs}
          fetchTagsInCards={fetchTagsInCards}
          tagsInCards={tagsInCards}
          handleSetSelectedTag={handleSetSelectedTag}
          saveCardDetails={saveCardDetails}
          setCardDetails={setCardDetails}
          setComments={setComments}
          cardUrl={selectedCard ? selectedCard.url : ""}
          fetchCoverColor={fetchCoverColor}
          fetchCoverImage={fetchCoverImage}
          coverColor={coverColor}
          coverImage={coverImage}
          fetchUsersInCards={fetchUsersInCards}
        />
        {selectedImage2 && (
          <div
            onClick={handleCloseImage2}
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 9999,
              backgroundColor: "#44505ab6",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%",
            }}
          >
            <img
              src={selectedImage2}
              alt="selected"
              style={{ maxWidth: "50%", maxHeight: "50%" }}
            />
          </div>
        )}
      </Box>
    </ErrorBoundary>
  );
}
export default Board;
